<template>
  <div class="mt-5 mr-3 ml-3">
    <h2 class="ma-3">My Offers</h2>

    <v-tabs v-model="activeTab" :centered="true" :grow="true" :center-active="true">
      <v-tab v-for="tab in tabs" :key="tab.title" :href="`#${tab.reservationCategory}`" :data-cy="tab.title">
        {{ tab.title }}
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="activeTab" class="mt-5">
      <v-tab-item v-for="tab in tabs" :key="tab.title" :value="`${tab.reservationCategory}`">
        <ReservationList :reservation-category="tab.reservationCategory" :url="tab.url" :data-cy="`${tab.reservationCategory}Offers`" />
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import Vue from 'vue'

import { ReservationCategory } from '@/enums/reservationCategory'
import ReservationList from '@/components/reservation/ReservationList.vue'

export default Vue.extend({
  name: 'MyOffers',

  metaInfo: {
    title: 'My Offers',
  },

  components: {
    ReservationList,
  },

  data: () => ({
    tabs: [
      { title: 'Incomplete', reservationCategory: ReservationCategory.INCOMPLETE, url: '/reservation/active' },
      { title: 'Claimed', reservationCategory: ReservationCategory.CLAIMED, url: '/reservation/reserved' },
      { title: 'Past', reservationCategory: ReservationCategory.PAST, url: '/reservation/past' },
    ],
  }),

  computed: {
    activeTab: {
      set(activeTab) {
        this.$router.replace({ params: { ...this.$route.params, category: activeTab } })
      },
      get() {
        return this.$route.params.category
      },
    },
  },
})
</script>

<style>
.v-slide-group__prev {
  display: none !important;
}
</style>
